import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import {
  BatchDefinitionDependenciesAPI,
  BatchDefinitionParametersAPI,
  BatchDefinitionsListAPI,
} from 'ducks/types/api-types';
import { BatchDefinitionItemCheckDep } from 'ducks/types/store-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

const getBatchDefinitionItemsList = async (batch_definition: number): Promise<BatchDefinitionsListAPI[]> => {
  const res: AxiosResponse['data'] = await Andromeda.get(
    `/batch_definitions/${batch_definition}/batch_definition_items/list`,
  );
  return res.data;
};

const getDependenciesList = async (id: number | null): Promise<BatchDefinitionDependenciesAPI[]> => {
  const res: AxiosResponse['data'] = await Andromeda.get(`/batch_definition_items/${id}/dependencies/list`);
  return res.data;
};

const getParametersList = async (id: number | null): Promise<BatchDefinitionParametersAPI[]> => {
  const res: AxiosResponse['data'] = await Andromeda.get(`/batch_definition_items/${id}/parameters/list`);
  return res.data;
};

export const getBatchDefinitionItemCheckDepAll = createAsyncThunk<BatchDefinitionItemCheckDep[], number>(
  `${Slices.BATCH_DEFINITION_DEP}/get`,
  async (batch_definition, { rejectWithValue }) => {
    try {
      const list = await getBatchDefinitionItemsList(batch_definition);
      const result: BatchDefinitionItemCheckDep[] = [];

      Object.values(list).forEach(async (el) => {
        const dependencies_list = await getDependenciesList(el.batch_definition_item_id);

        const current_params = await getParametersList(el.batch_definition_item_id);

        let children_params;

        if (dependencies_list.length > 0) {
          children_params = await getParametersList(dependencies_list[0]?.batch_definition_item_id);
        }
        result.push({
          children: dependencies_list[0]?.batch_definition_item_id,
          currentId: el.batch_definition_item_id,
          children_params: children_params || [],
          current_params: current_params || [],
        });
        if (result.length === Object.values(list).length) {
          return result;
        }
      });
      return result;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
